import {
    SET_ASSET_ITEM_STATUS_TASK_DETAIL,
    SET_IS_ASSET_ITEM_STATUS_TASK_DETAIL_CALLED
} from "./AssetItemStatusTaskDetailsType"

const initialState = {
    assetItemStatusTaskDetail: [],
    loadingStates: {} as any 
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_ITEM_STATUS_TASK_DETAIL:
            return {
                ...state,
                assetItemStatusTaskDetail: action.assetItemStatusTaskDetail
            };
        case SET_IS_ASSET_ITEM_STATUS_TASK_DETAIL_CALLED:
            const { fleetDetailId, isLoading } = action;
            return {
              ...state,
              loadingStates: {
                ...state.loadingStates,
                [fleetDetailId]: {
                  ...state.loadingStates[fleetDetailId],
                  isLoading: isLoading
                }
              }
            };
        default:
            return state;
    }
};

export default reducer;